import { all, propEq } from 'ramda';
import { offerCodeEnum } from '@@viewEnums';

const hasExtraUnrequiredFields = (form) => {
  const consentsLevels = form.watch('consents') || [];
  const markUpLevel = form.watch('markups.0.level') || false;
  const offerCode = form.getValues('offerCode');

  if (offerCode === offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION) {
    if (markUpLevel) {
      return true;
    }
    return all(propEq('level', true), consentsLevels);
  } else {
    return true;
  }
};

export default hasExtraUnrequiredFields;
